import { render } from "./SeWageIncomeDocument.vue?vue&type=template&id=bfbb2068&scoped=true"
import script from "./SeWageIncomeDocument.vue?vue&type=script&lang=js"
export * from "./SeWageIncomeDocument.vue?vue&type=script&lang=js"

import "./SeWageIncomeDocument.vue?vue&type=style&index=0&id=bfbb2068&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfbb2068"]])

export default __exports__